/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReplaceSeasonRequest
 */
export interface ReplaceSeasonRequest {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof ReplaceSeasonRequest
     */
    readonly $schema?: string;
    /**
     * Start date of the season
     * @type {Date}
     * @memberof ReplaceSeasonRequest
     */
    beginDate: Date;
    /**
     * End date of the season
     * @type {Date}
     * @memberof ReplaceSeasonRequest
     */
    endDate: Date;
    /**
     * Name of the season
     * @type {string}
     * @memberof ReplaceSeasonRequest
     */
    name: string;
    /**
     * Regular season start date of the season
     * @type {Date}
     * @memberof ReplaceSeasonRequest
     */
    regularSeasonBeginDate: Date;
    /**
     * Regular season end date of the season
     * @type {Date}
     * @memberof ReplaceSeasonRequest
     */
    regularSeasonEndDate: Date;
}

/**
 * Check if a given object implements the ReplaceSeasonRequest interface.
 */
export function instanceOfReplaceSeasonRequest(value: object): value is ReplaceSeasonRequest {
    if (!('beginDate' in value) || value['beginDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('regularSeasonBeginDate' in value) || value['regularSeasonBeginDate'] === undefined) return false;
    if (!('regularSeasonEndDate' in value) || value['regularSeasonEndDate'] === undefined) return false;
    return true;
}

export function ReplaceSeasonRequestFromJSON(json: any): ReplaceSeasonRequest {
    return ReplaceSeasonRequestFromJSONTyped(json, false);
}

export function ReplaceSeasonRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplaceSeasonRequest {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'beginDate': (new Date(json['begin_date'])),
        'endDate': (new Date(json['end_date'])),
        'name': json['name'],
        'regularSeasonBeginDate': (new Date(json['regular_season_begin_date'])),
        'regularSeasonEndDate': (new Date(json['regular_season_end_date'])),
    };
}

export function ReplaceSeasonRequestToJSON(json: any): ReplaceSeasonRequest {
    return ReplaceSeasonRequestToJSONTyped(json, false);
}

export function ReplaceSeasonRequestToJSONTyped(value?: Omit<ReplaceSeasonRequest, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'begin_date': value['beginDate'].toISOString(),
        'end_date': value['endDate'].toISOString(),
        'name': value['name'],
        'regular_season_begin_date': value['regularSeasonBeginDate'].toISOString(),
        'regular_season_end_date': value['regularSeasonEndDate'].toISOString(),
    };
}

